const pts = window.products;
const SpecialProducts = pts.map((p) => ({
  ...p,
  sub_title: p.id === 8502225993981 ? "From Cloudy To Clear Waters" : "Treats",
  price_title: "3 Month Supply For",
}));
console.log("SpecialProducts: ", SpecialProducts);

// script.js
const custom_openCart = document.querySelectorAll(".open-custom-cart");
const custom_closeCart = document.querySelectorAll(".close_cart_drawer");
const custom_overlay = document.querySelector("#custom_overlay");
const custom_cartDrawer = document.querySelector("#custom_cartDrawer");

function openCartDrawer() {
  document.querySelector(".gradient").classList.add("overflow-hidden");
  document.querySelector("#custom_cartDrawer").style.right = "0";
  document.querySelector("#custom_overlay").style.display = "block";
}

function closeCartDrawer() {
  document.querySelector(".gradient").classList.remove("overflow-hidden");
  document.querySelector("#custom_cartDrawer").style.right = "-440px";
  document.querySelector("#custom_overlay").style.display = "none";
}
custom_openCart.forEach((btn) => btn.addEventListener("click", openCartDrawer));
custom_closeCart.forEach((btn) =>
  btn.addEventListener("click", closeCartDrawer)
);

// ======= cart functionality start =======

async function updateCartItemCounts() {
  const res = await fetch("/cart.js");
  const cart = await res.json();

  var totalQuantity = 0;
  cart.items.forEach(function (item) {
    totalQuantity += item.quantity;
  });

  console.log("totalQuantity", totalQuantity);

  document.querySelectorAll(".cart-count-bubble").forEach((el) => {
    el.innerHTML = totalQuantity;
  });
}

function updateOpenCartDrawer(domHTml) {
  document.querySelector(".gradient").classList.add("overflow-hidden");
  domHTml.querySelector("#custom_cartDrawer").style.right = "0";
  domHTml.querySelector("#custom_overlay").style.display = "block";
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=custom-cart-drawer");
  const text = await res.text();

  const html = document.createElement("div");
  html.innerHTML = text;

  // opencartDrawer with new html
  updateOpenCartDrawer(html);
  updateCartItemCounts();

  const newBox = html.querySelector(".custom_cartDrawer_wrapper").innerHTML;
  document.querySelector(".custom_cartDrawer_wrapper").innerHTML = newBox;

  addCartDrawerListeners();
  // relatedProductsFace(8167159693565);
  // singleProduct();
  specialProducts();
}

// ========== quantity update ========
function addCartDrawerListeners() {
  document
    .querySelectorAll(".select_options select")
    .forEach((selectElement) => {
      selectElement.addEventListener("change", async (e) => {
        e.stopPropagation();
        e.preventDefault();
        document
          .querySelectorAll(".cartContent")
          .forEach((el) => el.classList.add("loading"));
        const selectedValue = Number(selectElement.value);
        const rootItem =
          selectElement.parentElement.parentElement.parentElement;
        const key = rootItem.getAttribute("data-line-item-key");
        console.log("key", key);

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: selectedValue } }),
        });
        const cart = await res.json();
        // Update cart
        await updateCartDrawer();
        document
          .querySelectorAll(".cartContent")
          .forEach((el) => el.classList.remove("loading"));
      });
    });

  // close cart when update quantity or delete product
  document.querySelectorAll(".close_cart_drawer").forEach((btn) =>
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();
      closeCartDrawer();
    })
  );
  document
    .querySelectorAll(".checkout_button")
    .forEach((btn) =>
      btn.addEventListener("click", (e) => (btn.innerText = "Processing..."))
    );

  // ========== Delete Item =========
  document.querySelectorAll(".cart_delete_button").forEach((deleteBtn) => {
    deleteBtn.addEventListener("click", async (e) => {
      e.stopPropagation();
      e.preventDefault();

      document
        .querySelectorAll(".cartContent")
        .forEach((el) => el.classList.add("loading"));
      const rootItem = deleteBtn.parentElement.parentElement;
      const key = rootItem.getAttribute("id");

      // Ajax delete
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });

      const res2 = await fetch("/cart.js");
      const cart = await res2.json();
      console.log("cart: ", cart);
      // Update cart
      await updateCartDrawer();
      document
        .querySelectorAll(".cartContent")
        .forEach((el) => el.classList.remove("loading"));
    });
  });
}

addCartDrawerListeners();

// Add to cart drawer when click on add to cart button
document.querySelectorAll(".add_to_cart_custom_btn").forEach((btn) => {
  btn.addEventListener("click", async (e) => {
    e.preventDefault();
    e.stopPropagation();
    var form = btn.closest("form");

    btn.innerText = "Adding...";
    // Get the value of product-variant-id input within the form
    const productVariantId = form.querySelector(".product-variant-id").value;
    data = {
      items: [
        {
          quantity: 1,
          id: Number(productVariantId),
        },
      ],
    };
    // Submit form with ajax
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("data", data.items[0].variant_id);
        updateCartDrawer();
        openCartDrawer();
        btn.innerText = "Add To cart";
      })
      .catch((err) => console.log(err));
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    openCartDrawer();
  });
});

document
  .querySelectorAll(".checkout_button")
  .forEach((btn) =>
    btn.addEventListener("click", (e) => (btn.innerText = "Processing..."))
  );
// ======= cart functionality end =======

// ======= related products start =======
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString?.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString?.replace(placeholderRegex, value);
}

function buildBlock(product) {
  // const formattedPrice = formatMoney(product.price, "{{ shop.money_format }}")
  // console.log(formattedPrice)

  const format = document
    .querySelector("[data-money-format]")
    ?.getAttribute("data-money-format");
  console.log("format", format);
  const formattedPrice = formatMoney(product.price, format);
  // console.log(formattedPrice);

  const html2 = `

    <div class="min-w-[350px] bg-[#F8F7F9] flex items-center gap-[16px] py-[7px] px-[18px] rounded-lg">
    <img
      width="80px"
      height="80px"
      class="w-20"
      src="${product.images?.[0]}"
      alt=""
    >
    <div>
      <h5 style="margin-bottom: 5px" class="font-semibold text-[14px]">${
        product.title
      }</h5>
      <div class="flex items-center justify-between">
      <div class="mt-3 text-[12px] font-bold flex gap-x-3">
        <p>${formattedPrice}</p>
        <p class="line-through opacity-50">${formatMoney(
          product.compare_at_price,
          format
        )}</p>
      </div>
      <div onclick="addItemToCart(${product.variants[0].id}, ${
    product.id
  })" class="self-end cursor-pointer bg-white hover:bg-primary hover:text-white duration-300 text-[13px] font-semibold py-2.5 px-[31px] rounded-full">
          Add
        </div>
      </div>
    </div>
    
  </div>
    
    `;

  const html = `
                 <div class="mb-3 rounded relative w-full order-6 lg:order-7 cursor-pointer">
                    <div class="product-selector !flex items-center p-2 gap-3 sm:gap-5 bg-slate-50">
                      <div class="sm:w-auto w-[50px] h-[50px] rounded-sm overflow-hidden">
                        <img src="${product.images?.[0]}" width="50" height="50" alt="product">
                      </div>
                      <div class="pro-info w-[65%]">
                        <h3 class="text-[13px] sm:text-[14px] font-bold mb-0.5 text-primary">${product.title}</h3>
                        <h3 class="text-[13px] font-medium text-primary">${product.sub_title}</h3>
                        <div class="flex items-center justify-start gap-2">
                          <h3 class="text-[13px] font-bold">3 Month Supply For ${formattedPrice}</h3>
                        </div>
                      </div>
                      <div class="min-w-[72px]">
                        <div product_id="${product.id}" onclick="addItemToCart(${product.variants[0].id}, ${product.id})" class="ml-auto text-center w-full bg-white rounded-full px-5 py-1 font-medium text-[15.24px] add_gel">
                          Add
                        </div>
                      </div>
                    </div>
                  </div>
    `;
  return html;
}

function relatedProductsFace(id) {
  fetch(
    window.Shopify.routes.root +
      `recommendations/products.json?product_id=${id}&limit=4`
  )
    .then((response) => response.json())
    .then(({ products }) => {
      console.log("relatedPorducts", products);
      products.forEach((product) => {
        const html = buildBlock(product);
        document.querySelectorAll(".all_related_products").forEach((all) => {
          all.innerHTML += html;
        });
      });
    });
}
// relatedProductsFace(8167159693565);

async function addItemToCart(variantId, product_id) {
  console.log("variantId: ", variantId);
  const addGel = document.querySelectorAll(".add_gel");
  addGel.forEach((el) => {
    const id = el.getAttribute("product_id");
    if (id != product_id) {
      el.innerText = "Add";
    } else {
      el.innerText = "Adding...";
    }
  });
  const res = await fetch("/cart.js");
  const cart = await res.json();

  const checkProduct = cart.items.find((i) => i.variant_id === variantId);
  console.log("checkProduct", checkProduct);

  let data2 = null;
  if (variantId === 0) return;
  if (checkProduct !== undefined) {
    // document.querySelector(".add_gel").innerText = "Add";
    // return;
    data2 = {
      items: [
        {
          quantity: checkProduct + 1,
          id: Number(variantId),
        },
      ],
    };
  } else {
    data2 = {
      items: [
        {
          quantity: 1,
          id: Number(variantId),
        },
      ],
    };
  }

  if (data2 === null) return;

  // const data2 = {
  //   items: [
  //     {
  //       quantity: 1,
  //       id: Number(variantId),
  //     },
  //   ],
  // };
  // Submit form with ajax
  await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data2),
  })
    .then((response) => {
      console.log("response: ", response);
      updateCartDrawer();
      // document.querySelector(".add_gel").innerText = "Add";
      addGel.forEach((el) => {
        el.innerText = "Add";
      });
    })
    .catch((err) => console.log(err));
}

// ======= related products end =======

// ======= single product start =======

async function singleProduct(handle = "gel-x3") {
  // console.log("root-location", window.Shopify.routes.root);
  const res2 = await fetch(
    `${window.Shopify.routes.root}products/${handle}.js`
  );
  const singleProduct = await res2.json();
  console.log("single-product: ", singleProduct);

  const html = buildBlock(singleProduct);
  document.querySelectorAll(".all_related_products").forEach((all) => {
    all.innerHTML += html;
  });
}
// singleProduct();

function specialProducts() {
  if (SpecialProducts.length === 0) return;

  SpecialProducts.forEach((product) => {
    const html = buildBlock(product);
    document.querySelectorAll(".all_related_products").forEach((all) => {
      all.innerHTML += html;
    });
  });
}

specialProducts();
